import { combineReducers } from 'redux';
import { reducer as app } from './AppRedux';
import { reducer as auth } from './AuthRedux';
import { reducer as coupons } from './CouponsRedux';
import { reducer as users } from './UsersRedux';
import { reducer as property } from './PropertyRedux';
import { reducer as client } from './ClientRedux';
import { reducer as pdfView } from './PdfViewRedux';
import { reducer as booking } from './BookingRedux';
import { reducer as regions } from './RegionsRedux';

const reducers = combineReducers({
  app,
  auth,
  coupons,
  users,
  property,
  client,
  pdfView,
  booking,
  regions
});

export default reducers;
